<template>
    <div>
        <div class="absolute -mt-1 md:-mt-7 pl-1 md:pl-3">
            <i class="text-sm text-green-warm-500 fas fa-minus"></i>
        </div>

        <form-row title="Total Loan Amount"
            :no_border="true"
            class="mb-3"
            label_class="ml-8 md:ml-0"
        >
            <input-money
                v-model="amount"
                name="total_loan_amount"
                :read_only="read_only"
            />
        </form-row>
    </div>
</template>

<script>
export default {
    props: {
        value: {},
        read_only: { default: false },
    },

    computed: {
        amount: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
}
</script>
